<template>
  <fieldset class="tab tab-08 none-bg">
    <div class="heading-form a-center">
      <span class="number">8/18</span>
      <p class="c-yellow">ความเสี่ยงจากอุบัติเหตุ</p>
      <h2 class="heading-h2 c-white">
        คุณใช้มือถือขณะขับรถยนต์หรือรถจักรยานยนต์
        <span class="br767">บ่อยเพียงใด</span>
      </h2>
      <p class="desc">(คุยโทรศัพท์, เล่นโซเชียล, ดูแผนที่, ฟังเพลง เป็นต้น)</p>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoUseTelOnDrive">
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio8"
                id="Nomobile"
                class="css-checkbox"
                value="-1"
                v-model="use_mobilephone"
              />
              <label for="Nomobile" class="css-label">ไม่ใช้เลย</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio8"
                id="23Monthmobile"
                class="css-checkbox"
                value="2-3month"
                v-model="use_mobilephone"
              />
              <label for="23Monthmobile" class="css-label"
                >2-3 เดือนครั้ง</label
              >
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio8"
                id="1Monthmobile"
                class="css-checkbox"
                value="1month"
                v-model="use_mobilephone"
              />
              <label for="1Monthmobile" class="css-label"
                >อย่างน้อยเดือนละครั้ง</label
              >
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio8"
                id="1Weekmobile"
                class="css-checkbox"
                value="1week"
                v-model="use_mobilephone"
              />
              <label for="1Weekmobile" class="css-label"
                >อย่างน้อยสัปดาห์ละครั้ง</label
              >
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio8"
                id="Everydaymobile"
                class="css-checkbox"
                value="everyday"
                v-model="use_mobilephone"
              />
              <label for="Everydaymobile" class="css-label"
                >ทุกวัน หรือเกือบทุกวัน</label
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-08', 'tab-07')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      id="btnNextStepQ9"
      type="button"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep3_Q8",
  props: {
    QuestionType: String
  },
  data() {
    return {
      use_mobilephone: my_storage(this.QuestionType, "use_mobilephone")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      if (this.use_mobilephone != "") {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
        this.nextStep("tab-08", "tab-09");
      }
    }
  },
  computed: {
    isPass() {
      return this.use_mobilephone != "";
    }
  }
};
</script>
